<template>
  <div class="flex flex-col z-50 gap-y-4">
    <div class="flex mobile:flex-col z-50 mobile:gap-y-4 gap-x-4">
      <div class="flex flex-col w-1/2 mobile:w-full mobile:pr-0 gap-y-2">
        <div class="data-container" v-if="taskData">
          <div class="data-container-header">
            <h4>Üldinfo</h4>
          </div>
          <div
            class="data-container-content data-container-content-hor gap-x-2 gap-y-2 text-sm"
          >
            <div class="flex gap-y-2 w-full gap-x-2 mobile:flex-col">
              <div class="flex gap-x-2 flex-col w-2/3 mobile:w-full">
                <div class="flex-col flex">
                  <h4>Tellimus</h4>
                  <div class="flex items-center gap-x-2 text-sm">
                    <span class="flex truncate items-center h-8">{{
                      taskData.related_object
                        ? taskData.related_object.object_name
                        : "-"
                    }}</span>
                    <button
                      v-if="(isAdmin || isManager) && taskData.status !== 6"
                      class="btn-primary"
                      @click="
                        $store.commit(
                          'modals/taskModal/setProjectSelectorModal',
                          true
                        )
                      "
                    >
                      Muuda
                    </button>
                    <button
                      v-if="
                        (isAdmin || isManager) &&
                        !taskData.related_object &&
                        taskData.status !== 6
                      "
                      class="btn-primary"
                      @click="
                        $store.dispatch(
                          'modals/taskModal/setShowNewProjectModal',
                          true
                        )
                      "
                    >
                      Lisa uus tellimus
                    </button>
                    <router-link
                      v-if="taskData.related_object && (isManager || isAdmin)"
                      :to="`/projects/${taskData.related_object.object_uuid}`"
                      target="_blank"
                    >
                      <button class="btn-primary">Vaata</button>
                    </router-link>
                  </div>
                </div>
                <div class="flex flex-col">
                  <div class="flex flex-col" v-if="taskData.related_object">
                    <h4>Klient</h4>
                    <div class="flex items-center gap-x-2 text-sm truncate">
                      <span
                        class="flex truncate items-center h-8 text-xl font-medium"
                      >
                        {{ taskData.related_object.client_name }}
                      </span>
                      <router-link
                        v-if="isAdmin || isManager"
                        :to="`/clients/${taskData.related_object.client_id}`"
                        target="_blank"
                      >
                        <button class="btn-primary">Vaata</button>
                      </router-link>
                    </div>
                  </div>
                </div>
                <div class="flex flex-col w-full" v-if="isAdmin || isManager">
                  <div class="flex flex-col mb-2">
                    <gwd-formlabel title="Maksja" />
                    <div
                      v-if="taskData.payer"
                      class="flex items-center gap-x-2 text-sm"
                    >
                      <span class="flex truncate items-center h-8">{{
                        taskData.payer.name
                      }}</span>
                      <router-link
                        v-if="isAdmin || isManager"
                        :to="`/clients/${taskData.payer.id}`"
                        target="_blank"
                      >
                        <button class="btn-primary">Vaata</button>
                      </router-link>
                      <button
                        v-if="(isManager || isAdmin) && taskData.status !== 6"
                        class="btn-primary"
                        @click="
                          $store.commit(
                            'modals/taskModal/showPayerSelector',
                            true
                          )
                        "
                      >
                        <span class="label">Muuda</span>
                      </button>
                    </div>
                    <div v-else class="flex items-center gap-x-2">
                      <span>-</span>
                      <button
                        v-if="(isManager || isAdmin) && taskData.status !== 6"
                        class="btn-primary"
                        @click="
                          $store.commit(
                            'modals/taskModal/showPayerSelector',
                            true
                          )
                        "
                      >
                        <span class="label">Vali</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex flex-col gap-x-2 gap-y-1 w-1/3 mobile:w-full">
                <div class="flex gap-x-2">
                  <div class="flex flex-col flex-1">
                    <div class="flex items-center justify-between">
                      <h4>Kuupäev</h4>
                      <div
                        v-if="
                          taskTime &&
                          taskTime.startDate &&
                          !moment(taskDataClone.start_time).isSame(
                            moment(taskTime.startDate),
                            'day'
                          ) &&
                          moment(taskTime.startDate).isBefore(moment(), 'day')
                        "
                      >
                        <div
                          class="bg-danger-dark px-1 rounded duration-100 inline-block"
                        >
                          <span class="text-white"> MINEVIK </span>
                        </div>
                      </div>
                    </div>
                    <DateSelector
                      v-model="taskTime.startDate"
                      v-if="(isAdmin || isManager) && taskTime"
                      :big-text="true"
                    />
                    <div v-else class="text-sm">
                      <span v-if="taskTime">{{
                        moment(taskTime.startDate).format("DD.MM.YYYY")
                      }}</span>
                    </div>
                  </div>
                </div>
                <div
                  class="flex gap-x-2"
                  v-if="taskTime && !taskData.all_day && taskTime.startDate"
                >
                  <div class="flex flex-col flex-1">
                    <div class="flex-1">
                      <h4>Algus</h4>
                    </div>
                    <div class="flex-1">
                      <TimeSelector
                        v-model="taskTime.startTime"
                        @input="handleStartTimeUpdate"
                        v-if="isAdmin || isManager"
                        class="text-sm"
                      />
                      <div v-else class="text-sm">
                        <span v-if="!taskData.all_day">{{
                          `${formatTimeUnit(
                            taskTime.startTime.hour
                          )}:${formatTimeUnit(taskTime.startTime.minute)}`
                        }}</span>
                        <span v-else class="text-sm"> Terve päev </span>
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-col flex-1">
                    <div class="flex-1"><h4>Kestvus</h4></div>
                    <div class="flex-1">
                      <DurationSelector
                        @updated="handleDurationUpdate"
                        :initial-duration="taskDuration"
                        v-if="isAdmin || isManager"
                        class="text-sm"
                        :pos="mobileView ? 'm' : 'br'"
                      />
                      <div v-else class="text-sm">
                        <span v-if="!taskData.all_day">
                          {{
                            `${formatTimeUnit(
                              taskDuration.hours
                            )}:${formatTimeUnit(taskDuration.minutes)}`
                          }}
                        </span>
                        <span v-else class="text-sm"> Terve päev </span>
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-1 flex-col">
                    <div class="flex-1"><h4>Lõpp</h4></div>
                    <div class="flex-1">
                      <span class="text-sm px-1" v-if="!taskData.all_day">{{
                        `${taskTime.endTime.hour}:${
                          taskTime.endTime.minute.toString().length === 1
                            ? "0" + taskTime.endTime.minute
                            : taskTime.endTime.minute
                        }`
                      }}</span>
                      <span v-else class="text-sm"> Terve päev </span>
                    </div>
                  </div>
                </div>
                <div v-if="taskData.all_day" class="flex gap-x-2">
                  <div class="flex flex-col flex-1">
                    <div class="flex-1"><h4>Kestvus</h4></div>
                    <div class="flex flex-row items-center">
                      <span>Terve päev</span>
                      <gwd-checkbox
                        v-if="isAdmin || isManager"
                        v-model="taskData.all_day"
                        class="ml-auto"
                        :size="`6`"
                      />
                    </div>
                  </div>
                </div>
                <div
                  v-if="taskTime && !taskTime.startDate"
                  class="flex gap-x-2"
                >
                  <div class="flex flex-col flex-1">
                    <div class="flex-1"><h4>Kestvus</h4></div>
                    <div class="flex flex-row items-center">
                      <span>Ajatu töö</span>
                    </div>
                  </div>
                </div>
                <div class="flex gap-x-2" v-if="isManager || isAdmin">
                  <div class="flex-1"><h4>Kõigile nähtav</h4></div>
                  <gwd-checkbox
                    v-if="isAdmin || isManager"
                    v-model="taskData.is_public"
                    class="ml-auto"
                    :size="`6`"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <skeleton-content v-else></skeleton-content>
        <div
          class="data-container hidden lg:hidden md:block sm:block safari-desktop-hide"
          v-if="canStartTimer"
        >
          <div class="data-container-header">
            <h4>Taimer</h4>
            <div
              class="flex items-center justify-end rounded text-white font-medium gap-x-2"
            >
              <div
                class="bg-primary rounded flex font-medium items-center gap-x-2 px-2 w-32 justify-center"
                v-if="taskHasActiveTimer"
              >
                <img
                  src="/new/time.svg"
                  class="h-5 w-5 filter-to-white"
                  alt="Timer logo"
                />
                <span>{{ activeTimerDisplay }}</span>
              </div>
              <button
                class="ml-auto"
                :class="taskHasActiveTimer ? 'btn-danger' : 'btn-primary'"
                @click="taskHasActiveTimer ? stopTimer() : startTimer()"
                v-if="
                  !timerRequestRunning && taskData.status !== 6 && !blockTimer
                "
              >
                {{ taskHasActiveTimer ? "Lõpeta" : "Alusta" }}
              </button>
              <div class="flex" v-else-if="timerRequestRunning || blockTimer">
                <ClipLoader size="20px" />
              </div>
            </div>
            <span v-if="!taskHasActiveTimer" class="ml-auto font-medium">
              Kogutööaeg
            </span>
            <span
              v-if="!taskHasActiveTimer"
              class="bg-primary px-1 text-white font-medium rounded"
            >
              {{ workerTotalWorkTime }}
            </span>
          </div>
          <div class="data-container-content" v-if="taskHasActiveTimer">
            <gwd-textarea
              type="text"
              v-model="taskWorkerInfo"
              placeholder="Lisainfo taimeri kohta"
              :max-length="256"
            />
          </div>
          <task-timer
            v-if="
              !taskHasActiveTimer &&
              timerData &&
              timerData.length > 0 &&
              taskData.payment_info === null &&
              taskData.status !== 6
            "
            @setPaymentInformation="setPaymentInformation"
          />
          <div
            v-if="
              taskData.payment_info &&
              Object.keys(taskData.payment_info).length > 0
            "
            class="data-container-content"
          >
            <div
              class="grid"
              :class="
                taskData.payment_info.payment_worker.id === this.workerId
                  ? 'grid-cols-2'
                  : 'grid-cols-6'
              "
            >
              <gwd-formlabel title="Maksetüüp" />

              <span>{{
                taskData.payment_info.payment_type === 1
                  ? "Sularaha"
                  : "Kaardimakse"
              }}</span>
              <gwd-formlabel title="Summa" />
              <span>{{ taskData.payment_info.payment_amount }}</span>

              <gwd-formlabel
                v-if="taskData.payment_info.payment_worker.id !== this.workerId"
                title="Vastuvõtja"
              />

              <span
                v-if="taskData.payment_info.payment_worker.id !== this.workerId"
              >
                {{ taskData.payment_info.payment_worker.worker_name }}
              </span>
            </div>
            <div
              class="grid"
              :class="
                taskData.payment_info.payment_worker.id === this.workerId
                  ? 'grid-cols-2'
                  : 'grid-cols-3'
              "
            >
              <span>{{
                taskData.payment_info.payment_type === 1
                  ? "Sularaha"
                  : "Kaardimakse"
              }}</span>
              <span>{{ taskData.payment_info.payment_amount }}</span>
              <span
                v-if="taskData.payment_info.payment_worker.id !== this.workerId"
              >
                {{ taskData.payment_info.payment_worker.worker_name }}
              </span>
            </div>
          </div>
        </div>
        <div class="data-container" v-if="isAdmin || isManager">
          <div class="data-container-header">
            <h4>Kirjeldus</h4>
            <div
              v-if="taskData.related_object && !taskDataChanged"
              class="flex ml-auto"
            >
              <button
                :class="
                  taskData.related_object.project_details_length >= 2024
                    ? 'btn-disabled'
                    : taskData.related_object.project_details_length +
                      taskData.description
                    ? taskData.description.length
                    : 0 <= 2024
                    ? 'btn-primary'
                    : 'btn-attention'
                "
                @click="appendToProject(true)"
              >
                Lisa tellimuse kirjeldusse
              </button>
            </div>
          </div>
          <div class="data-container-content mb-2">
            <gwd-textarea
              v-model="taskData.description"
              class="text-sm"
              :max-length="2048"
            />
          </div>
          <div class="data-container-header">
            <h4>Info töödejuhatajatele</h4>
            <div
              v-if="taskData.related_object && !taskDataChanged"
              class="flex ml-auto"
            >
              <button
                :class="
                  taskData.related_object.project_invoice_text_length >= 2024
                    ? 'btn-disabled'
                    : taskData.related_object.project_invoice_text_length +
                      taskData.manager_description
                    ? taskData.manager_description.length
                    : 0 <= 2024
                    ? 'btn-primary'
                    : 'btn-attention'
                "
                @click="appendToProject(false)"
              >
                Lisa arve infosse
              </button>
            </div>
          </div>
          <div class="data-container-content mb-2">
            <gwd-textarea
              v-model="taskData.manager_description"
              class="text-sm"
              :max-length="1024"
            />
          </div>
        </div>
      </div>
      <div
        class="flex flex-col w-1/2 mobile:w-full gap-y-2 mobile:gap-y-4 justify-start"
      >
        <div class="data-container">
          <div class="data-container-header">
            <h4>Asukoht</h4>
          </div>
          <div class="data-container-content text-sm">
            <task-location-selector></task-location-selector>
          </div>
        </div>
        <div class="data-container" v-if="isManager || isAdmin">
          <div
            class="data-container-header cursor-pointer"
            @click="editTags = !editTags"
          >
            <h4>Sildid</h4>
          </div>
          <div class="data-container-content text-sm">
            <div
              v-if="!editTags"
              class="flex items-center gap-x-1 flex-wrap gap-y-1"
            >
              <div
                v-for="selectedTag in taskData.tags"
                :key="selectedTag"
                class="px-1 bg-primary rounded duration-100 text-white inline-block"
              >
                <span> {{ selectedTag }}</span>
              </div>
            </div>
            <add-task-tag-selector v-if="editTags" :existing="true" />
          </div>
        </div>
        <div
          class="data-container"
          v-if="
            (isManager || isAdmin) &&
            taskData.outgoing_invoices &&
            taskData.outgoing_invoices.length > 0
          "
        >
          <div class="data-container-header cursor-pointer">
            <h4>Arved</h4>
          </div>
          <div class="data-container-content text-sm">
            <div class="flex items-center gap-x-1">
              <span
                class="px-1 py-0.5 cursor-pointer inline-block rounded font-medium"
                :class="
                  invoice.manually_checked
                    ? 'bg-green'
                    : 'bg-pending text-white'
                "
                v-for="invoice in taskData.outgoing_invoices"
                :key="invoice.id"
                @click.left.exact="routeToOutgoingInvoice(invoice)"
                @click.middle.exact="routeToOutgoingInvoice(invoice)"
                @click.ctrl.exact="routeToOutgoingInvoice(invoice)"
              >
                Arve
                {{
                  invoice.manually_checked
                    ? `nr: ${invoice.invoice_nr}`
                    : `id: ${invoice.id}`
                }}
              </span>
            </div>
          </div>
        </div>
        <div class="data-container mobile:hidden" v-if="canStartTimer">
          <div class="data-container-header">
            <h4>Taimer</h4>
            <div
              class="flex items-center justify-end rounded text-white font-medium gap-x-2"
            >
              <div
                class="bg-primary rounded flex font-medium items-center gap-x-2 px-2 w-32 justify-center"
                v-if="taskHasActiveTimer"
              >
                <img
                  src="/new/time.svg"
                  class="h-5 w-5 filter-to-white"
                  alt="Timer logo"
                />
                <span>{{ activeTimerDisplay }}</span>
              </div>
              <button
                class="ml-auto"
                :class="taskHasActiveTimer ? 'btn-danger' : 'btn-primary'"
                @click="taskHasActiveTimer ? stopTimer() : startTimer()"
                v-if="
                  !timerRequestRunning && taskData.status !== 6 && !blockTimer
                "
              >
                {{ taskHasActiveTimer ? "Lõpeta" : "Alusta" }}
              </button>
              <div class="flex" v-else-if="timerRequestRunning || blockTimer">
                <ClipLoader size="20px" />
              </div>
            </div>
            <span class="ml-auto font-medium"> Minu kogutööaeg </span>
            <span class="bg-primary px-1 text-white font-medium rounded">{{
              workerTotalWorkTime
            }}</span>
          </div>
          <div class="data-container-content" v-if="taskHasActiveTimer">
            <gwd-textarea
              type="text"
              v-model="taskWorkerInfo"
              placeholder="Lisainfo taimeri kohta"
              :max-length="256"
            />
          </div>
          <task-timer
            v-if="
              !taskHasActiveTimer &&
              timerData &&
              timerData.length > 0 &&
              taskData.payment_info === null
            "
            @setPaymentInformation="setPaymentInformation"
          />
          <div
            v-if="
              taskData.payment_info &&
              Object.keys(taskData.payment_info).length > 0
            "
            class="data-container-content"
          >
            <div
              class="grid"
              :class="
                taskData.payment_info.payment_worker.id === this.workerId
                  ? 'grid-cols-2'
                  : 'grid-cols-3'
              "
            >
              <gwd-formlabel title="Maksetüüp" />
              <gwd-formlabel title="Summa" />
              <gwd-formlabel
                v-if="taskData.payment_info.payment_worker.id !== this.workerId"
                title="Vastuvõtja"
              />
            </div>
            <div
              class="grid"
              :class="
                taskData.payment_info.payment_worker.id === this.workerId
                  ? 'grid-cols-2'
                  : 'grid-cols-3'
              "
            >
              <span>{{
                taskData.payment_info.payment_type === 1
                  ? "Sularaha"
                  : "Kaardimakse"
              }}</span>
              <span>{{ taskData.payment_info.payment_amount }}</span>
              <span
                v-if="taskData.payment_info.payment_worker.id !== this.workerId"
              >
                {{ taskData.payment_info.payment_worker.worker_name }}
              </span>
            </div>
          </div>
        </div>
        <div
          v-if="(isManager || isManager) && taskData.payment_info !== null"
          class="data-container"
        >
          <div class="data-container-header">
            <h4>Töö tasumise info</h4>
          </div>
          <div v-if="taskData.payment_info" class="data-container-content">
            <div class="grid grid-cols-3">
              <gwd-formlabel title="Maksetüüp" />
              <gwd-formlabel title="Summa" />
              <gwd-formlabel title="Vastuvõtja" />
            </div>
            <div class="grid grid-cols-3">
              <span>{{
                taskData.payment_info.payment_type === 1
                  ? "Sularaha"
                  : "Kaardimakse"
              }}</span>
              <span>{{ taskData.payment_info.payment_amount }}</span>
              <span>
                {{ taskData.payment_info.payment_worker.worker_name }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <location-modal
        v-if="locationModal.show"
        :start-location="locationModal.data.start_location"
        :end-location="locationModal.data.end_location"
        :task-location="taskData.location"
        @closeModal="() => (locationModal = { show: false, data: null })"
      />
    </div>
    <div
      class="flex w-full gap-x-4 flex-col mobile:gap-y-4"
      v-if="!(isAdmin || isManager)"
    >
      <div class="data-container w-full">
        <div class="data-container-header">
          <h3>Kirjeldus</h3>
        </div>
        <div class="data-container-content">
          <p>{{ taskData.description ? taskData.description : "-" }}</p>
        </div>
      </div>
      <div class="data-container">
        <div class="data-container-header">
          <h4>Töötajad</h4>
        </div>
        <div
          v-for="worker in taskData.workers"
          :key="worker.id"
          class="p-2 font-medium"
        >
          {{ worker.worker_name }}
        </div>
        <div v-if="taskData.workers.length === 0" class="p-2">
          <span>Kõik töötajad</span>
        </div>
      </div>
      <div class="data-container" v-if="taskData.equipment">
        <div class="data-container-header">
          <h3>Tehnika</h3>
        </div>
        <div class="data-container-content">
          <div
            class="flex flex-row mobile:flex-col mobile:gap-x-2 mobile:gap-y-2 mobile:justify-start"
            v-for="taskEquipment in taskData.equipment"
            :key="taskEquipment.id"
          >
            <h4 class="flex-1">{{ taskEquipment.name }}</h4>
            <span class="flex-1">{{
              taskEquipment.location ? taskEquipment.location.long_address : "-"
            }}</span>
          </div>
        </div>
      </div>
      <task-resource-assignments
        :task-id="String(taskData.id)"
        :task-confirmed="taskData.status === 6"
        class="mobile:mr-1"
      />
      <task-extra-cost-assignments
        :task-id="String(taskData.id)"
        :task-confirmed="taskData.status === 6"
        class="mr-1"
      />
      <task-supplier-assignments
        :task-id="String(taskData.id)"
        :task-confirmed="taskData.status === 6"
        class="mobile:mr-1"
      />
    </div>
    <div class="flex flex-col" v-if="isManager || isAdmin">
      <task-workers v-if="taskData.workers" ref="taskWorkers" />
      <task-equipment
        v-if="
          taskData.assigned_equipment_list &&
          taskData.assigned_equipment_list.length > 0 &&
          $refs.taskWorkers &&
          !$refs.taskWorkers.showEditMenu
        "
        ref="taskEquipment"
      />
      <task-extra-cost-assignments
        v-if="
          $refs.taskWorkers &&
          !$refs.taskWorkers.showEditMenu &&
          taskData.sub_tasks.length > 0
        "
        :task-id="String(taskData.id)"
        class="mr-1"
      />
      <skeleton-content
        v-if="!taskData.worker && !taskData.assigned_equipment_list"
      />
    </div>
  </div>
</template>
<script>
import LocationModal from "@/components/reusable/LocationModal";
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import TimeSelector from "../../reusable/TimeSelector.vue";
import DurationSelector from "@/components/reusable/DurationSelector";
import DateSelector from "../../globals/DateSelector.vue";
import TaskWorkers from "./TaskWorkers";
import { vMaska } from "maska";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import {
  formatTimeUnit,
  generateParamString,
  parseTimerData,
} from "@/assets/utils/commonTransforms";
import SkeletonContent from "../../reusable/SkeletonContent.vue";
import TaskLocationSelector from "@/components/tasks/TaskLocationSelector";
import TaskEquipment from "@/components/tasks/taskmodal/TaskEquipment.vue";
import { debounce } from "lodash";
import TaskResourceAssignments from "@/components/tasks/costs/TaskResourceAssignments.vue";
import TaskExtraCostAssignments from "@/components/tasks/costs/TaskExtraCostAssignments.vue";
import AddTaskTagSelector from "@/components/tasks/AddTaskTagSelector.vue";
import TaskSupplierAssignments from "@/components/tasks/costs/TaskSupplierAssignments.vue";
import TaskTimer from "@/components/tasks/taskmodal/TaskTimer.vue";

export default {
  components: {
    TaskTimer,
    TaskSupplierAssignments,
    AddTaskTagSelector,
    TaskExtraCostAssignments,
    TaskResourceAssignments,
    TaskEquipment,
    LocationModal,
    TimeSelector,
    DateSelector,
    TaskWorkers,
    DurationSelector,
    ClipLoader,
    SkeletonContent,
    TaskLocationSelector,
  },
  directives: {
    maska: vMaska,
  },
  mounted() {
    if (this.activeTimer) this.startActiveTimerDisplay();
    this.taskTime = this.initTaskTime();
  },
  beforeDestroy() {
    clearInterval(this.activeTimerInterval);
  },
  data() {
    return {
      activeTimerDisplay: "",
      activeTimerInterval: null,
      moment: moment,
      showTimeEntries: false,
      taskTime: null,
      taskDuration: { hours: 1, minutes: 0 },
      taskWorkerPay: 0,
      taskWorkerInfo: "",
      timerRequestRunning: false,
      locationModal: {
        show: false,
        data: null,
      },
      editTags: false,
    };
  },
  methods: {
    formatTimeUnit,
    resize() {
      console.log(window.innerWidth, window.innerHeight);
    },
    appendToProject(details = true) {
      let params;
      if (details) {
        params = {
          details: true,
          overflow:
            (this.taskData.related_object.project_details_length +
            this.taskData.description
              ? this.taskData.description.length
              : 0) >= 2000,
        };
      } else {
        params = {
          manager_details: true,
          overflow:
            (this.taskData.related_object.project_invoice_text_length +
            this.taskData.manager_description
              ? this.taskData.manager_description.length
              : 0) >= 2000,
        };
      }
      this.apiRequest(
        `notes/${this.companyId}/append/${
          this.taskData.related_object.object_uuid
        }/${this.taskData.id}/${generateParamString(params)}`,
        "patch",
        true
      )
        .then((res) => {
          if (res.status === 200)
            this.$store.dispatch(
              "modals/taskModal/retrieveTask",
              this.modalData.task
            );
        })
        .catch((err) => {
          if (err.response.status === 400) {
            this.$store.dispatch("messageHandler/throwMessage", {
              type: "error",
              text: "Kirjelduse lisamine ebaõnnestus, lisa käsitsi.",
              error: err,
            });
          }
        });
    },
    setPaymentInformation(paymentInfo) {
      this.apiRequest(
        `tasks/${this.modalData.task}/payment/set/`,
        "post",
        true,
        paymentInfo
      )
        .then((res) => {
          if (res.status === 200)
            this.$store.dispatch(
              "modals/taskModal/retrieveTask",
              this.modalData.task
            );
        })
        .catch((err) => {
          if (err.response.status === 400) {
            this.$store.dispatch("messageHandler/throwMessage", {
              type: "error",
              text: "Makseinfo on juba täidetud.",
              error: err,
            });
          }
        });
    },
    initTaskTime() {
      let taskTime = {};
      if (!this.taskData.start_time && !this.taskData.end_time) {
        return {
          startDate: null,
          startTime: null,
          endDate: null,
          endTime: null,
        };
      }
      taskTime.startDate = moment(this.taskData.start_time);
      taskTime.startTime = {
        hour: moment(this.taskData.start_time).hour(),
        minute: moment(this.taskData.start_time).minute(),
      };
      taskTime.endDate = moment(this.taskData.end_time);
      taskTime.endTime = {
        hour: moment(this.taskData.end_time).hour(),
        minute: moment(this.taskData.end_time).minute(),
      };

      let diff = moment.duration(
        moment(this.taskData.end_time).diff(moment(this.taskData.start_time))
      );
      this.taskDuration = {
        hours: diff.days() * 24 + diff.hours(),
        minutes: diff.minutes(),
      };

      return taskTime;
    },
    startTimer() {
      this.timerRequestRunning = true;
      this.$store
        .dispatch("timetracking/startTimer", this.modalData.task)
        .then(() => {
          this.timerRequestRunning = false;
          this.$store.dispatch(
            "modals/taskModal/retrieveTimerData",
            this.modalData.task
          );
          this.$store.dispatch(
            "modals/taskModal/retrieveTask",
            this.modalData.task
          );
          this.startActiveTimerDisplay();
        })
        .catch(() => {
          this.timerRequestRunning = false;
        });
    },
    stopTimer() {
      this.timerRequestRunning = true;
      this.$store
        .dispatch("timetracking/stopTimer", {
          estimatedWorkerPay: this.taskWorkerPay,
          taskWorkerInfo: this.taskWorkerInfo,
        })
        .then(() => {
          this.timerRequestRunning = false;
          this.$store.dispatch(
            "modals/taskModal/retrieveTimerData",
            this.modalData.task
          );
          this.$store.dispatch(
            "modals/taskModal/retrieveTask",
            this.modalData.task
          );
          clearInterval(this.activeTimerInterval);
          this.taskWorkerInfo = "";
        })
        .catch(() => {
          this.timerRequestRunning = false;
          this.$store.dispatch("messageHandler/throwMessage", {
            type: "error",
            text: "Aja kinni panemine ebaõnnestus!",
            ttl: 5,
          });
        });
    },
    startActiveTimerDisplay() {
      this.taskWorkerInfo = this.activeTimer.info ? this.activeTimer.info : "";
      const setDisplay = () => {
        this.activeTimerDisplay = moment
          .utc(
            moment
              .duration(moment().diff(moment(this.activeTimer.stopper_start)))
              .asMilliseconds()
          )
          .format("HH:mm:ss");
      };
      this.$nextTick(() => {
        setDisplay();
        this.activeTimerInterval = setInterval(() => {
          setDisplay();
        }, 1000);
      });
    },
    handleStartTimeUpdate(e) {
      if (!e) return;
      this.taskTime.startTime = e;
      let endMoment = moment(this.taskTime.startDate)
        .set({ hour: e.hour, minute: e.minute })
        .add(this.taskDuration.hours, "hour")
        .add(this.taskDuration.minutes, "minute");

      this.taskTime.endTime = {
        hour: endMoment.hour(),
        minute: endMoment.minute(),
      };
    },
    debounceSaveTimerInfo: debounce(function () {
      if (this.taskHasActiveTimer)
        this.apiRequest(
          `tasks/${this.activeTimer.task_id}/stopper/${this.activeTimer.id}/edit/`,
          "patch",
          true,
          { info: this.taskWorkerInfo }
        );
    }, 500),
    handleEndTimeUpdate(e) {
      this.taskData.end_time = e;
      let startMoment = moment(this.taskTime.startDate)
        .hour(e.hour)
        .minute(e.minute)
        .subtract(this.taskDuration.hours, "h")
        .subtract(this.taskDuration.minutes, "m");

      this.taskTime.startTime = {
        hour: startMoment.hour(),
        minute: startMoment.minute(),
      };
    },
    handleDurationUpdate(e) {
      if (!this.taskTime.startTime) return;
      this.taskDuration = { hours: e.hours, minutes: e.minutes ?? 0 };
      let currState = moment(this.taskTime.startDate)
        .hour(this.taskTime.startTime.hour)
        .minute(this.taskTime.startTime.minute);
      let updatedState = moment(currState)
        .add(parseInt(e.hours), "h")
        .add(parseInt(e.minutes), "m");
      this.taskTime.endTime = {
        hour: updatedState.hour(),
        minute: updatedState.minute(),
      };
    },
    routeToOutgoingInvoice(invoice) {
      const route = this.$router.resolve({
        path: invoice.manually_checked
          ? `/invoices/outgoing/confirmed/${invoice.id}`
          : `/invoices/outgoing/${invoice.id}`,
        query: {
          view: 6,
        },
      });
      window.open(route.href, "_blank");
    },
  },
  computed: {
    ...mapGetters({
      modalData: "modals/taskModal/data",
      timerData: "modals/taskModal/timerData",
      workerId: "companyData/workerId",
      userId: "userData/userId",
      activeTimer: "timetracking/activeTimer",
      userRole: "companyData/userPermission",
      todos: "modals/taskModal/todos",
      taskDataClone: "modals/taskModal/taskDataClone",
      isAdmin: "companyData/isAdmin",
      isManager: "companyData/isManager",
      blockTimer: "timetracking/blockTimer",
      taskDataChanged: "modals/taskModal/taskDataChanged",
      companyId: "companyData/activeCompanyUuid",
    }),
    ...mapState({
      taskData: (state) => state.modals.taskModal.taskData,
    }),
    canStartTimer() {
      return (
        (this.taskDataClone?.workers.map((x) => x.id).includes(this.workerId) &&
          this.taskData?.workers.map((x) => x.id).includes(this.workerId) &&
          (this.isDayOfTask || this.taskHasActiveTimer)) ||
        (this.taskData.is_public && this.isDayOfTask && this.taskHasActiveTimer)
      );
    },
    taskHasActiveTimer() {
      return (
        this.activeTimer && this.activeTimer.task_id === this.modalData.task
      );
    },
    isDayOfTask() {
      if (!this.taskTime?.startDate) return false;
      return moment(this.taskTime.startDate).isSame(moment(), "day");
    },
    startTime() {
      if (!this.taskTime?.startDate) return null;
      return moment(this.taskTime.startDate)
        .hour(this.taskTime.startTime?.hour ?? 9)
        .minute(this.taskTime.startTime?.minute ?? 0)
        .format("YYYY-MM-DD[T]HH:mm:ssZ");
    },
    endTime() {
      if (!this.startTime) return null;
      return moment(this.startTime)
        .add(this.taskDuration.hours, "hours")
        .add(this.taskDuration.minutes, "minutes")
        .format("YYYY-MM-DD[T]HH:mm:ssZ");
    },
    workerTotalWorkTime() {
      if (!this.timerData) return null;
      return parseTimerData(this.timerData, this.userId);
    },
    mobileView() {
      return window.innerWidth <= 601;
    },
  },
  watch: {
    "taskTime.startDate"() {
      this.taskData.start_time = this.startTime;
      if (this.taskTime.startDate && !this.taskTime.startTime) {
        this.taskTime.startTime = {
          hour: 9,
          minute: 0,
        };
        this.taskTime.endDate = moment(this.taskTime.startDate).add(1, "day");
        this.taskTime.endTime = {
          hour: 9,
          minute: 0,
        };
      }
      this.taskData.end_time = this.endTime;
    },
    "taskTime.startTime"() {
      this.taskData.start_time = this.startTime;
      this.taskData.end_time = this.endTime;
    },
    "taskTime.endTime"() {
      this.taskData.start_time = this.startTime;
      this.taskData.end_time = this.endTime;
    },
    taskWorkerInfo() {
      if (this.activeTimerDisplay && this.taskWorkerInfo)
        this.debounceSaveTimerInfo();
    },
  },
};
</script>
